export default __webpack_public_path__ + "static/media/BREAKIN.e9e1c763.svg";